import BusinessInfo from "components/BusinessInfo";

export default BusinessInfo;
